import React from 'react';
import { useTranslation } from 'react-i18next';
import { Edit as EditInterface } from '../../../../interfaces/invoice.interface';
import Avatar from 'react-avatar';
import Badge from '../../../../components/Badge';
import Spinner from '../../../../components/Spinner';
import { TransactionStatus } from '../../../../interfaces/transaction.interface';
import { INVOICE_STATUS } from '../../../../utils/appConstant';
import NoPropertyImg from '../../../../assets/img/custom/no-property.jpeg';
import ElipsisText from '../../../../components/ElipsisText';
import { AuthRoutes, Modules, RouteParamsTypes } from '../../../../enums';
import Link from '../../../../components/Link';

interface DetailsProps {
  loading: boolean;
  formData: EditInterface;
}

const Details: React.FC<DetailsProps> = ({ loading, formData }) => {
  const { t } = useTranslation();

  const getStatusVariant = (status: TransactionStatus) => {
    if (status === INVOICE_STATUS.reconciled) return "danger";
    else if (status === INVOICE_STATUS.draft) return "secondary";
    else if (status === INVOICE_STATUS.sent) return "warning";
    else if (status === INVOICE_STATUS.overdue) return "warning";
    else if (status === INVOICE_STATUS.completed) return "success";
    else return "info"
  }

  return (
    <div className="card mb-6">
      <div className="card-body">
        <div className="row">
          {
            loading
              ?
              (
                <div className='text-center'>
                  <Spinner />
                </div>
              )
              :
              (
                <div>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className='col-4'>
                      <div className="d-flex align-items-center">
                        <div className="me-2" style={{ width: 50 }}>
                          <Avatar src={formData.propertyImg || NoPropertyImg} name={formData.property} size="50" maxInitials={2} round />
                        </div>
                        <div style={{ width: 'calc(100% - 60px)' }}>
                          <ElipsisText
                            text={formData.property || '-'}
                            node={
                              <Link 
                                text={formData.property || "-"} 
                                href={`${Modules.resources}${AuthRoutes.properties}${RouteParamsTypes.view}/${formData.propertyId}`}
                                target="_blank"
                              />
                            }
                            className="mb-0 app-brand-text fw-semibold demo"
                            width='100%'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-4 text-center'>
                      <h5 className="mb-0">{formData.customer || '-'}</h5>
                    </div>
                    <div className='col-4 text-center'>
                      <h5 className="mb-0">{formData.invoiceNo || '-'}</h5>
                    </div>
                  </div>

                  <hr className="my-4 mx-n4" />

                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="mb-0"><b>{formData.month || '-'}</b></p>
                      <p className="mb-0">{t("invoices.editPreviewPayment.pageTexts.form.month")}</p>
                    </div>
                    <div className='border-end'>
                      &nbsp; <br /> &nbsp;
                    </div>
                    <div>
                      <p className="mb-0"><b>{formData.invoiceDateApi || '-'}</b></p>
                      <p className="mb-0">{t("invoices.editPreviewPayment.pageTexts.form.invoiceDateLabel")}</p>
                    </div>
                    <div className='border-end'>
                      &nbsp; <br /> &nbsp;
                    </div>
                    <div>
                      <p className="mb-0"><b>{formData.dueDateApi || '-'}</b></p>
                      <p className="mb-0">{t("invoices.editPreviewPayment.pageTexts.form.dueDateLabel")}</p>
                    </div>
                    <div className='border-end'>
                      &nbsp; <br /> &nbsp;
                    </div>
                    <div className='pe-3'>
                      <p className="mb-0"><b>{formData.bookingTypeName || '-'}</b></p>
                      <p className="mb-0">{t("invoices.editPreviewPayment.pageTexts.form.propertyBookingType")}</p>
                    </div>
                    <div className='border-end'>
                      &nbsp; <br /> &nbsp;
                    </div>
                    <div className='pe-3'>
                      <p className="mb-0"><b>{`${formData.commission} %` || '-'}</b></p>
                      <p className="mb-0">{t("invoices.editPreviewPayment.pageTexts.form.casaCommission")}</p>
                    </div>
                    {formData.managerStatement && (
                      <>
                        <div className='border-end'>
                          &nbsp; <br /> &nbsp;
                        </div>
                        <div className='pe-3'>
                          <p className="mb-0">
                            <Link
                              text={formData.managerStatement.statementNumber}
                              href={`${Modules.reconciliation}${RouteParamsTypes.managerStatement}/${formData.managerStatement.id}`}
                              target="_blank"
                              className="fw-bold text-decoration-underline hyperlink"
                            />
                          </p>
                          <p className="mb-0">{t("invoices.editPreviewPayment.pageTexts.form.statementNumber")}</p>
                        </div>
                      </>
                    )}
                    <div></div>
                  </div>
                  
                  <div className="d-flex justify-content-end align-items-center" style={{ position: 'absolute', top: 0, right: 0 }}>
                    <Badge
                      className="px-3 py-2 fw-medium fs-6"
                      variant={getStatusVariant(formData.status as any)}
                      style={{
                        borderRadius: '0px 10px 0px 10px'
                      }}
                      text={formData.statusName}
                    />
                  </div>
                </div>
              )
          }
        </div>
      </div>
    </div>
  );
};

export default Details;
